import React, { useEffect, useState } from "react";
import serverConfig from "../config";
import SecondaryMenu from "../SecondaryMenu";

function Regulation() {
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const contentRegulation = (
    <>
      <iframe
        title="pdf-preview"
        src={`${serverConfig.serverUrl}/file/regulation/regolamentoDSM.pdf#toolbar=0`}
        width="100%"
        height="600px"
      />
    </>
  );

  return (
    <div>
      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>
              <div
                className="col-12 col-lg-10"
                style={{ padding: "15px", color: "#2C2C2C" }}
              >
                {contentRegulation}
              </div>
            </div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              <div
                className="col-12 col-lg-10"
                style={{ padding: "15px", color: "#2C2C2C" }}
              >
                {contentRegulation}
              </div>
            </div>
          </>
        )}
      </div>
      {/*}
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true}></SecondaryMenu>
        </div>
        <div className="col-12 col-lg-10">
          <iframe
            title="pdf-preview"
            src={`${serverConfig.serverUrl}/file/regulation/regolamentoDSM.pdf#toolbar=0`}
            width="100%"
            height="100%"
          />
        </div>
      </div>
      */}
    </div>
  );
}

export default Regulation;
